/**
 * Capture a thumbnail from the 3D viewport.
 *
 * Delegates entirely to __poseref_captureThumbnail (ExportHelper in
 * Viewport3D.tsx), which:
 *   - Owns a direct reference to gl.domElement — no DOM query that could
 *     accidentally match a CubeSpinner or other unrelated canvas.
 *   - Hides gizmos, grid, and other overlays before rendering.
 *   - Routes through PostProcessing when active.
 *   - In path-trace mode, reads from the PT canvas (preserveDrawingBuffer).
 *   - Crops the center square and returns a 256×256 WebP blob.
 *
 * Pass `isolateObjectIds` to render only those scene objects (plus any
 * lights) — used by library save so the asset's preview is uncluttered.
 */
export async function captureViewportThumbnail(
  size = 256,
  isolateObjectIds?: ReadonlySet<string> | null,
): Promise<Blob | null> {
  const fn = window.__poseref_captureThumbnail;
  if (typeof fn !== "function") return null;
  return fn(size, isolateObjectIds);
}
